import { render } from "./list.vue?vue&type=template&id=237e94ac&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=237e94ac&scoped=true&lang=css"

import exportComponent from "D:\\boya_project\\boya_web_mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237e94ac"]])

export default __exports__